export default {
  allowCreateQuestions: 'Allow creating Questions',
  allowCreateQuestionsTooltip: 'This option allows you to create different types of questions within the {entity}.',
  questionOptions: 'Question Options',
  questionOptionsTooltip: 'Question options that can be within the {entity}.',
  redaction: 'Essay',
  matching: 'Matching',
  simpleSelection: 'Single Selection',
  multipleSelection: 'Multiple Selection',
}
